import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import FilterGroup from '@components/FilterGroup'
import { Autocomplete, Dropdown } from '@components/Autocomplete'
import { SearchPanelContainer } from '@components/Search'

class ProjectsPipelineFilterPanel extends Component {
  static propTypes = {
    projectsPipelineStore: PropTypes.object
  }

  filterByAtheneumContact = contact => {
    const { projectsPipelineStore } = this.props
    if (contact) {
      projectsPipelineStore.selectedAtheneumContact = contact
      projectsPipelineStore.query.atheneumContact = contact.value
    } else {
      projectsPipelineStore.selectedAtheneumContact = null
      projectsPipelineStore.query.atheneumContact = ''
    }
    projectsPipelineStore.filter()
  }

  filterByAtheneumOffice (id) {
    const { projectsPipelineStore } = this.props
    projectsPipelineStore.query.atheneumOffice = id
    projectsPipelineStore.filter()
  }

  onClearSearch = () => {
    this.props.projectsPipelineStore.clearSearch()
  }

  render () {
    const {
      selectedAtheneumContact,
      atheneumOffices,
      query
    } = this.props.projectsPipelineStore
    return (
      <SearchPanelContainer
        extrathin
        searchTitle='Search and Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Atheneum contact'>
          <Autocomplete
            value={selectedAtheneumContact}
            itemToString={item => item && item.label}
            onChange={this.filterByAtheneumContact}
            loadOptions={
              this.props.projectsPipelineStore.autocompleteAtheneumContact
            }
          />
        </FilterGroup>
        <FilterGroup label='Atheneum office'>
          <Dropdown
            valueIsId
            selectedItem={query.atheneumOffice}
            itemToString={item => item && item.name}
            options={atheneumOffices}
            onChange={office => {
              if (!office) return
              this.filterByAtheneumOffice(office.id)
            }}
          />
        </FilterGroup>
      </SearchPanelContainer>
    )
  }
}

export default inject('projectsPipelineStore')(
  observer(ProjectsPipelineFilterPanel)
)
